import React from 'react';
import { gettext } from '@eventbrite/i18n';

import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton,
} from 'react-share';

const SubSectionLinks = ({ subSections }) => {
    const subSectionLinks = subSections.map((subSection) => {
        if (subSection.title) {
            const anchorLink =
                '#' + subSection.title.replace(/ /g, '-').toLowerCase();
            return (
                <li key={anchorLink}>
                    <a href={anchorLink}>{subSection.title}</a>
                </li>
            );
        }
    });
    return <ul>{subSectionLinks}</ul>;
};

const SectionLinks = ({ sections, countryName }) => {
    const sectionLinks = sections.map((section) => {
        const anchorLink = '#' + section.title.replace(/ /g, '-').toLowerCase();
        return (
            <li key={anchorLink}>
                <a href={anchorLink}>{section.title}</a>
                {section.subSections && (
                    <SubSectionLinks subSections={section.subSections} />
                )}
            </li>
        );
    });
    return (
        <ul>
            {sectionLinks}
            {(countryName === 'Australia' ||
                countryName === 'United States') && (
                <li>
                    <a href="#state">
                        State by State Stimulus Packages & Policies
                    </a>
                </li>
            )}
            {countryName === 'United States' && (
                <li>
                    <a href="#private-company-programs">
                        Private Company Programs
                    </a>
                </li>
            )}
        </ul>
    );
};

const CountryHeader = ({ info }) => {
    const shareMessage = gettext(
        'Helpful resource for small businesses looking for Coronavirus (COVID-19) financial relief and loan information.',
    );

    // Don't try to render the URL during SSR, but instead render null first
    // for hydration:
    const [url, setUrl] = React.useState(null);
    React.useEffect(() => {
        setUrl(window.location.href);
    }, []);

    return (
        <div className="eds-g-group">
            <div className="eds-g-cell eds-g-cell-mn-4-12 eds-g-sm-cell-1-1 eds-l-pad-right-12">
                <div>
                    <div className="eds-text-hm eds-l-mar-bot-1">
                        {info.countryName}
                    </div>
                    <div className="eds-text-bl">
                        {gettext('Last updated:')} {info.lastUpdated}
                    </div>
                    <div className="eds-l-mar-top-8">
                        <p className="eds-text-bl eds-l-mar-bot-2">
                            {gettext('Share with your network:')}
                        </p>
                        <div className="covid-share-icon">
                            <EmailShareButton url={url} subject={shareMessage}>
                                <EmailIcon size="48" round={true} />
                            </EmailShareButton>

                            <FacebookShareButton url={url} quote={shareMessage}>
                                <FacebookIcon size="48" round={true} />
                            </FacebookShareButton>

                            <LinkedinShareButton
                                url={url}
                                title={shareMessage}
                                source="Eventbrite"
                            >
                                <LinkedinIcon size="48" round={true} />
                            </LinkedinShareButton>

                            <TelegramShareButton url={url} title={shareMessage}>
                                <TelegramIcon size="48" round={true} />
                            </TelegramShareButton>

                            <TwitterShareButton
                                url={url}
                                title={shareMessage}
                                related="@Eventbrite"
                            >
                                <TwitterIcon size="48" round={true} />
                            </TwitterShareButton>

                            <WhatsappShareButton url={url} title={shareMessage}>
                                <WhatsappIcon size="48" round={true} />
                            </WhatsappShareButton>
                        </div>
                    </div>
                </div>
            </div>
            <div className="eds-g-cell eds-g-cell-mn-8-12 eds-g-sm-cell-1-1">
                {info.introSection}
                <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
                    Financial relief options include
                </p>
                <SectionLinks
                    sections={info.sections}
                    countryName={info.countryName}
                />
                <div
                    className="eds-l-mar-vert-16 eds-bg-color--grey-300"
                    style={{ height: '1px' }}
                />
            </div>
        </div>
    );
};

export default CountryHeader;
